import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createHttpLink } from "@apollo/client/link/http";
import { environment } from "../config/environment";

const { graphqlUrl :  GRAPHQL_URI }  = environment;

const httpLink = createHttpLink({
  uri: GRAPHQL_URI,
  credentials: "include",
});

export default function createSimpleApolloClient() {
  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
  });
}
